"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CompareUtil {
    static deepEquals(v1, v2) {
        if (v1 === v2) {
            return true;
        }
        if (v1 === null && v2 === undefined || v1 === undefined && v2 === null) {
            return false;
        }
        const v1ToString = Object.prototype.toString.call(v1);
        if (v1ToString !== Object.prototype.toString.call(v2)) {
            return false;
        }
        let l, p, x, y;
        switch (v1ToString) {
            default: // Boolean, Date, String
                return v1.valueOf() === v2.valueOf();
            case "[object Number]":
                // Converts Number instances into primitive values
                // This is required also for NaN test bellow
                v1 = +v1;
                v2 = +v2;
                return v1 ? // a is Non-zero and Non-NaN
                    v1 === v2
                    : // a is 0, -0 or NaN
                        v1 === v1 ? // a is 0 or -O
                            1 / v1 === 1 / v2 // 1/0 !== 1/-0 because Infinity !== -Infinity
                            : v2 !== v2 // NaN, the only Number not equal to itself!
                ;
            // [object Number]
            case "[object Function]":
                return false; // functions should be strictly equal because of closure context
            // [object Function]
            case "[object Array]":
                if ((l = v1.length) !== v2.length) {
                    return false;
                }
                // Both have as many elements
                while (l--) {
                    if ((x = v1[l]) === (y = v2[l]) && x !== 0 || CompareUtil.deepEquals(x, y)) {
                        continue;
                    }
                    return false;
                }
                return true;
            // [object Array]
            case "[object Object]":
                l = 0; // counter of own properties
                for (p in v1) {
                    if (v1.hasOwnProperty(p)) {
                        ++l;
                        if ((x = v1[p]) === (y = v2[p]) && x !== 0 || CompareUtil.deepEquals(x, y)) {
                            continue;
                        }
                        return false;
                    }
                }
                // Check if 'b' has as not more own properties than 'a'
                for (p in v2) {
                    if (v2.hasOwnProperty(p) && --l < 0) {
                        return false;
                    }
                }
                return true;
            // [object Object]
        }
    }
}
exports.default = CompareUtil;
//# sourceMappingURL=CompareUtil.js.map